import { render, staticRenderFns } from "./ProjectClosureNotification.vue?vue&type=template&id=0f69c2e1&"
import script from "./ProjectClosureNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectClosureNotification.vue?vue&type=script&lang=js&"
import style0 from "./ProjectClosureNotification.vue?vue&type=style&index=0&id=0f69c2e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports